import { useCallback } from 'react'
import Icon from '@mdi/react'
import { mdiArrowRight, mdiFolderOutline } from '@mdi/js'
import { FormattedMessage } from 'react-intl'
import { UseTableRowProps } from 'react-table'

import IntlFormattedDate from 'app/i18n/IntlFormattedDate'
import theme from 'theme_'

import {
  MobileJobTableItemInfoRight,
  MobileJobTableItemInfoTitle,
  MobileJobTableItemHeader,
  MobileJobTableItem,
  MobileJobTableItemNarrowRow,
} from './styles'
import { jobsTablesMessages } from '../DomainJobsHomesTable/messages'
import { StyledJobFolderIcon } from '../DomainPendingJobsTable/styles'
import { PendingJobColumnType } from 'features/domains/types'
import { createJobUrl } from 'features/domains/utils'
import { useHistory } from 'react-router-dom'
import { useAppSelector } from 'app/hooks'
import { currentRootDomainIdSelector } from 'features/rootDomains/selectors'

interface MobilePendingJobProps {
  values: Record<string, any>
  original: UseTableRowProps<PendingJobColumnType>['original']
}

function MobilePendingJobComponent(props: MobilePendingJobProps) {
  const history = useHistory()
  const currentRootId = useAppSelector(currentRootDomainIdSelector)

  const { name, updated } = props.values

  const handleJobItemClick = useCallback(() => {
    const jobId = props.original.id
    const homeUrl = createJobUrl(currentRootId, jobId)

    history.push(homeUrl)
  }, [currentRootId, history, props.original.id])

  return (
    <MobileJobTableItem tabIndex={0} onClick={handleJobItemClick}>
      <MobileJobTableItemHeader dark>
        <div>
          <StyledJobFolderIcon path={mdiFolderOutline} size={1} />
          {name}
        </div>
        <Icon
          path={mdiArrowRight}
          size={1}
          color={theme.colors.horizonOrange}
        />
      </MobileJobTableItemHeader>

      <MobileJobTableItemNarrowRow>
        <MobileJobTableItemInfoTitle>
          <FormattedMessage {...jobsTablesMessages.updated} />
        </MobileJobTableItemInfoTitle>
        <MobileJobTableItemInfoRight>
          <IntlFormattedDate date={updated} withTime />
        </MobileJobTableItemInfoRight>
      </MobileJobTableItemNarrowRow>
    </MobileJobTableItem>
  )
}

export default MobilePendingJobComponent
